(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.unveil = {
    attach: function (context, settings) {

      $('.unveil').unveil(150, function() {
        if ($(this).hasClass('js-object-fit-image')) {
          objectFitPolyfill($(this)[0]);
        }
      });

    }
  };

})(jQuery, Drupal);
